import actions from "./stateDistrictActions";
import { error } from "highcharts";
import comleteStateDistrict from "../../Components/Data/StatesDistrictTalukasVersion2";
const { stateDistrictActions } = actions;

const getStateDistrictList = async (dispatch) => {
  try {
    let completeData = comleteStateDistrict;

    comleteStateDistrict.reduce((ans, ele) => {
return {
  
}
    }, {
      district: {},
      talukas: {},
    });

    let data = { state: Object.keys(completeData) };

    dispatch(stateDistrictActions(data));
  } catch (err) {
    console.log(error);
  }
};

export { getStateDistrictList };
